<template>
    <div>
        <ListEdit
            v-model="model.options"
            @handleAdd="addOption"
            @handleRemove="removeOption"
            label="Opciones"
            :minItems="2"
        >
            <template #default="{ index }">
                <div class="d-flex form-check align-items-center">
                    <input
                        :value="index"
                        v-model="radioIndex" 
                        type="radio"
                        class="form-check-input flex-shrink-0 pb-1 mb-1 me-2"
                        tabindex="-1"
                        :id="'isCorrectRadio' + index"
                        required
                    >                

                    <input
                        v-model="model.options[index].label"
                        type="text"
                        class="form-control form-control-sm"
                        :placeholder="`Opción ${index + 1}`"
                        id="optionName"
                        required
                    >
                </div>
            </template>
        </ListEdit>
    </div>
</template>

<script>
import ListEdit from '@/components/shared/List-edit.vue';

export default {
    name: 'SingleChoiceQuestion',

    props: {
        question: {
            type: Object,
            required: true,
        },
    },

    components: {
        ListEdit,
    },

    data() {
        return {
            model: this.question,
            radioIndex: null,
            prevRadioIndex: null,
        }
    },

    mounted() {
        if (this.model.options.length == 0) {
            this.addOption();
            this.addOption();
        }

        for (let [index, option] of Object.entries(this.model.options)) {
            if (option.isCorrect) {
                this.radioIndex = index
                break
            }
        }
     },

    methods: {
        addOption() {
            this.model.options.push({
                label: '',
                isCorrect: false,
            });
        },
        removeOption(index) {
            this.model.options.splice(index, 1);
            this.radioIndex = null
            this.prevRadioIndex = null
        }
    },

    watch: {
        model: {
            handler(newValue) {
                this.$emit('input', newValue)
            },
            deep: true
        },
        radioIndex() {
            if (this.prevRadioIndex !== null) {
                this.$set(this.model.options[this.prevRadioIndex], 'isCorrect', false)
            }
    
            this.$set(this.model.options[this.radioIndex], 'isCorrect', true)
            this.prevRadioIndex = this.radioIndex
        }
    }
}
</script>
